__turbopack_context__.v({
  "ButtonSpacer": "jMxtga_ButtonSpacer",
  "Close_Button": "jMxtga_Close_Button",
  "DropDownMenu": "jMxtga_DropDownMenu",
  "DropDownMenu_Button": "jMxtga_DropDownMenu_Button",
  "DropDownMenu_Links": "jMxtga_DropDownMenu_Links",
  "Link": "jMxtga_Link",
  "Open": "jMxtga_Open",
});
